export default __webpack_public_path__ + "aaf5f160eb5e80aa550ab2a27ee01e60.svg";